import React from 'react'
import { withTranslator } from '../HOCComponents/withTranslator'
import styled from 'styled-components'
import { ReactComponent as LayersLogo } from '../../assets/img/layers-logo-mono.svg'
import { UIStyles } from '../../theme'
import { APPLE_STORE_URL, ANDROID_STORE_URL, APP_DEEP_LINK_BASE_URL } from '@layers-frontend/commons/constants'

/*----------- Styled components -----------*/

export const RadialGradientBG = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: radial-gradient(119.22% 119.22% at 4.02% 8.7%, #4d2359 0%, #1c2541 36.46%, #1a3844 69.41%, #688245 100%);
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  overflow-x: auto;
  overflow-y: auto;
`

export const Logo = styled(LayersLogo)`
  width: 21rem;
  height: auto;
  color: ${UIStyles.whiteColor};
  align-self: center;
  margin-bottom: 15px;
`
export const LogoButton = styled.a`
  display: flex;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2rem;
`

export const Message = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  align-self: center;
  color: white;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 45px;
`

export const ButtonsBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  gap: 2rem;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  text-align: center;
  color: white;
  background-color: transparent;
`

export const ButtonText = styled.label`
  font-size: 1.8em;
  color: white;
  background-color: transparent;
`

export const Button = styled.a`
  width: 11rem;
  height: 11rem;
  display: flex;
  justify-content: center;
  align-self: center;
  text-align: center;
  font-size: 5rem;
  border-radius: 50%;
  border: 0.5rem solid;
  color: white;
  background-color: transparent;
`

export const ContinueInMobileButton = styled.button`
  width: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 2rem 2;
  margin: 0;
  font-size: 2.5rem;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-bottom: 2rem;
`

export const ButtonLabel = styled.h3`
  font-size: 2.8rem;
`

class AlertMobile extends React.Component {
  handleOpenAppStore = () => {
    const storeURL = this.props.isIOS ? APPLE_STORE_URL : ANDROID_STORE_URL

    window.open(storeURL, '_blank').focus()
  }

  handleOpenApp = () => {
    const url = `${APP_DEEP_LINK_BASE_URL}?token=${this.props.apiKey}`

    window.open(url, '_self').focus()
  }

  render() {
    const { t, isIOS } = this.props
    return (
      <Wrapper>
        <RadialGradientBG />
        <Message>{t('Try our mobile app for a better experience')}</Message>
        <ButtonsBox>
          <ButtonWrapper>
            <Button onClick={this.handleOpenAppStore}>
              <i className={isIOS ? 'fab fa-apple' : 'fab fa-google-play'} style={{ alignSelf: 'center' }} />
            </Button>
            <ButtonText>{t('Download')}</ButtonText>
          </ButtonWrapper>
          <ButtonWrapper>
            <Button onClick={this.handleOpenApp}>
              <i className={'fas fa-mobile-alt'} style={{ alignSelf: 'center' }} />
            </Button>
            <ButtonText>{t('Mobile app')}</ButtonText>
          </ButtonWrapper>
          <ButtonWrapper>
            <Button onClick={this.props.continueInMobile}>
              <i className={'fas fa-globe'} style={{ alignSelf: 'center' }} />
            </Button>
            <ButtonText>{t('Continue in web')}</ButtonText>
          </ButtonWrapper>
        </ButtonsBox>
        <LogoButton onClick={this.handleOpenApp}>
          <Logo />
        </LogoButton>
      </Wrapper>
    )
  }
}

export default withTranslator(AlertMobile)
